import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/newhome/title.png'


const _withScopeId = n => (_pushScopeId("data-v-dbb93ff0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scheme" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-dbb93ff0><img src=\"" + _imports_0 + "\" alt=\"\" data-v-dbb93ff0><div class=\"text\" data-v-dbb93ff0>备件采购</div><img src=\"" + _imports_0 + "\" alt=\"\" data-v-dbb93ff0></div><div class=\"title1\" data-v-dbb93ff0>海量现货，品质保障</div>", 2)
const _hoisted_4 = { class: "good-list container" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "left-box" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "right" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "pic" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "txt" }
const _hoisted_13 = { class: "title-two nowrap" }
const _hoisted_14 = { class: "price" }
const _hoisted_15 = { class: "click-num" }
const _hoisted_16 = { class: "lefts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attrArr, (item, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              onClick: ($event: any) => (_ctx.active(index)),
              class: _normalizeClass({ 'active': _ctx.isActive == index })
            }, _toDisplayString(item.name), 11, _hoisted_7))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodslit.datas.data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              class: "goods-info",
              onClick: ($event: any) => (_ctx.gotoGoods(item.id))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  class: "pic-img",
                  src: _ctx.getImgUrl(item.photo)
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.names), 1),
                _createElementVNode("div", _hoisted_14, " ¥ " + _toDisplayString(item.price), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.click) + "次浏览", 1)
                ])
              ])
            ], 8, _hoisted_9)
          ]))
        }), 128))
      ])
    ])
  ]))
}